/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontContactButton_seller$ref: FragmentReference;
export type StorefrontContactButton_seller = {|
  +serviceId: ?string,
  +$refType: StorefrontContactButton_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontContactButton_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e40e078ed7e25c3329a991d14ec00f41';
module.exports = node;
